export enum IconSize {
    SMALL = 16,
    MEDIUM = 24,
    LARGE = 32,
    XLARGE = 48,
    XXLARGE = 72,
    XXXLARGE = 100,
    XXXXLARGE = 150,
}
